import { Grid2 } from "@mui/material";
import UpcomingInvoiceStyle from "./UpcomingInvoice.module.scss";
import { useSelector } from "react-redux";

function UpcomingInvoice(props) {
  const { planPrice, WAFCount, WAFPrice, TaxAmount, estimatedBill } = props;

  const selectedOrg = useSelector(
    (state) => state.organizationsInfo?.selectedOrg
  );

  let orgCountry = selectedOrg?.country;

  const invoiceItems = [
    {
      label: `Plan price`,
      value: `${orgCountry === "USA" ? "$" : "₹"} ${planPrice}`,
    },
    // ...(singleSitePlan
    //   ? []
    //   : [
    //       {
    //         label: `Additional Site (${additionalSiteCount})`,
    //         value: additionalSitePrice,
    //       },
    //     ]),
    {
      label: `WAF (${WAFCount})`,
      value: WAFPrice,
    },
  ];
  if (TaxAmount) {
    invoiceItems.push({
      label: "Tax",
      value: orgCountry === "USA" ? "$ " : "₹ " + TaxAmount,
    });
  }

  return (
    <Grid2 className={UpcomingInvoiceStyle.container}>
      <Grid2 className={UpcomingInvoiceStyle.flexbox}>
        <Grid2>
          <Grid2 className={UpcomingInvoiceStyle.heading}>
            Upcoming Invoice
          </Grid2>
          <Grid2 className={UpcomingInvoiceStyle.mapItems}>
            {invoiceItems.map((item, index) => (
              <Grid2 item key={index}>
                <Grid2 className={UpcomingInvoiceStyle.items}>
                  <Grid2 item>{item.label}</Grid2>
                  <Grid2 item>{item.value}</Grid2>
                </Grid2>
              </Grid2>
            ))}
          </Grid2>
        </Grid2>
        <Grid2>
          <Grid2 className={UpcomingInvoiceStyle.headerLine}></Grid2>
          <Grid2 item className={UpcomingInvoiceStyle.estimatedTotalText}>
            <Grid2
              container
              className={UpcomingInvoiceStyle.estimatedTotalContainer}
            >
              <Grid2>Estimated bill</Grid2>
              <Grid2>
                {orgCountry === "USA" ? "$" : "₹"} {estimatedBill}
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}

export default UpcomingInvoice;
